var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "#545454",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87325 5.38872L2.42268 9.83907C2.2081 10.0536 1.86003 10.0536 1.64546 9.83907L1.12632 9.31993C0.911975 9.10559 0.911746 8.75843 1.1254 8.54363L4.65266 5.00012L1.12563 1.45637C0.911746 1.24157 0.912204 0.89441 1.12655 0.680067L1.64569 0.160929C1.86026 -0.0536418 2.20833 -0.0536417 2.4229 0.160929L6.87325 4.61151C7.08782 4.82608 7.08782 5.17415 6.87325 5.38872Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.1d379d9fb41dd54dfb0b58babc92d15b.svg";
export { ForwardRef as ReactComponent };